import { Markdown, Prose } from '@criteria-labs/react-typography'
import { Inset, Scroll } from '@criteria-labs/react'
import { useEffect, useState } from 'react'
import { useDocumentText } from '../documents/Document'
import { MarkdownDocument } from '../documents/MarkdownDocument'
import { ErrorBoundary } from './ErrorBoundary'

export function MarkdownDocumentPreview({ document }: { document: MarkdownDocument }) {
  const markdown = useDocumentText(document)

  // filter out undefined values as text is written to avoid flickering
  const [lastMarkdown, setLastMarkdown] = useState(markdown)
  useEffect(() => {
    if (lastMarkdown) {
      setLastMarkdown(lastMarkdown)
    }
  }, [lastMarkdown])

  return (
    <ErrorBoundary>
      <Scroll>
        <article className="p-3 lg:p-8">
          <Prose className="mx-auto max-w-7xl">
            <Markdown>{markdown}</Markdown>
          </Prose>
        </article>
      </Scroll>
    </ErrorBoundary>
  )
}
